var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { LENDI_BOT_IDENTITY, LendiMemberType } from '../';
var generateMessageMemberStatus = function (members, messageIndex, messageAuthor) {
    var authorMember; // The author
    var readByMembers = []; // ALL members who has read the message
    var currentMembers = []; // ALL members who's lastReadMessage is the current one
    // Using 1 loop instead of 3
    members.forEach(function (member) {
        if (member.identity === messageAuthor) {
            authorMember = member;
        }
        if (member.lastConsumedMessageIndex === messageIndex) {
            if (member.identity !== LENDI_BOT_IDENTITY) {
                currentMembers.push(member);
            }
        }
        if (member.lastConsumedMessageIndex >= messageIndex) {
            if (member.identity !== LENDI_BOT_IDENTITY) {
                readByMembers.push(member);
            }
        }
    });
    var seenByNames = generateSeenByNames(readByMembers, members);
    return {
        authorMember: authorMember,
        currentMembers: currentMembers,
        seenByNames: seenByNames,
    };
};
var generateSeenByNames = function (readByMembers, allMembers) {
    var seenByNames;
    if (readByMembers.length === 0) {
        // readByMembers not ready yet
    }
    else if (readByMembers.length === allMembers.length - 1) {
        // readByMembers will ALWAYS exclude lendi_bot, hence -1
        seenByNames = 'everyone';
    }
    else if (readByMembers.length === 1) {
        // readByMembers only has 1 member
        seenByNames = readByMembers[0].firstName;
    }
    else {
        var seenByMembers = readByMembers;
        var lastSeenMember = seenByMembers.pop();
        seenByNames = "".concat(seenByMembers.map(function (m) { return m.firstName; }).join(', '), " and ").concat(lastSeenMember === null || lastSeenMember === void 0 ? void 0 : lastSeenMember.firstName);
    }
    return seenByNames;
};
export var parseLendiMessage = function (message, members) {
    var index = message.index, authorIdentity = message.authorIdentity;
    var _a = generateMessageMemberStatus(members, index, authorIdentity), authorMember = _a.authorMember, seenByNames = _a.seenByNames, currentMembers = _a.currentMembers;
    return __assign(__assign({}, message), { author: authorMember, currentMembers: currentMembers, seenByNames: seenByNames });
};
export var parseTwilioMessage = function (message, members) {
    var index = message.index, body = message.body, author = message.author, dateCreated = message.dateCreated;
    var _a = generateMessageMemberStatus(members, index, author), authorMember = _a.authorMember, seenByNames = _a.seenByNames, currentMembers = _a.currentMembers;
    return {
        index: index,
        text: body,
        authorIdentity: author,
        author: authorMember,
        dateCreated: dateCreated,
        currentMembers: currentMembers,
        seenByNames: seenByNames,
    };
};
export var parseLendiMember = function (member, descriptor) {
    if (member.identity === descriptor.identity) {
        var identity = descriptor.identity, online = descriptor.online, attributes = descriptor.attributes;
        var userAttributes = attributes;
        var isTyping = member.isTyping, lastConsumedMessageIndex = member.lastConsumedMessageIndex;
        var defaultFirstName = userAttributes.type === LendiMemberType.CUSTOMER ? 'Customer' : 'Home Loan Specialist';
        var firstName = userAttributes.firstName ? formatName(userAttributes.firstName) : defaultFirstName;
        var lastName = userAttributes.lastName ? formatName(userAttributes.lastName) : '';
        var profilePictureURL = userAttributes.profilePictureURL;
        return {
            identity: identity,
            isOnline: online,
            isTyping: isTyping,
            firstName: firstName,
            lastName: lastName,
            type: userAttributes.type,
            lastConsumedMessageIndex: lastConsumedMessageIndex !== null && lastConsumedMessageIndex !== void 0 ? lastConsumedMessageIndex : 0,
            profilePictureURL: profilePictureURL,
        };
    }
    else {
        throw new Error('parseLendiMember(): member and userDescriptor mismatch');
    }
};
// conversations types are different from old chat SDK so there is a need to parse it differenlty
export var parseLendiConversationMember = function (member, user) {
    if (member.identity === user.identity) {
        var identity = user.identity, isOnline = user.isOnline, attributes = user.attributes;
        var userAttributes = attributes;
        var isTyping = member.isTyping, lastReadMessageIndex = member.lastReadMessageIndex;
        var defaultFirstName = userAttributes.type === LendiMemberType.CUSTOMER ? 'Customer' : 'Home Loan Specialist';
        var firstName = userAttributes.firstName ? formatName(userAttributes.firstName) : defaultFirstName;
        var lastName = userAttributes.lastName ? formatName(userAttributes.lastName) : '';
        var profilePictureURL = userAttributes.profilePictureURL;
        return {
            identity: identity,
            isOnline: !!isOnline,
            isTyping: isTyping,
            firstName: firstName,
            lastName: lastName,
            type: userAttributes.type,
            lastConsumedMessageIndex: lastReadMessageIndex !== null && lastReadMessageIndex !== void 0 ? lastReadMessageIndex : 0,
            profilePictureURL: profilePictureURL,
        };
    }
    else {
        throw new Error('parseLendiMember(): member and userDescriptor mismatch');
    }
};
export var formatName = function (name) {
    return name.charAt(0).toUpperCase() + name.slice(1);
};
//# sourceMappingURL=parsers.js.map